import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';

/**
 * GetTrashBinAllBusinessUseCase
 */
export class GetTrashBinAllBusinessUseCase {
  /**
   * ゴミ箱の集計情報の全てのIDを取得
   * @param repository - 在庫情報のリポジトリ
   * @param filterItems - フィルターの一覧
   */
  static async execute(repository: ITrashBinRepository, filterItems: FilterContentItem[]): Promise<INetworkResult<Array<string>, IError>> {
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    const networkResult = await repository.getTrashBinAllBusiness(filterItem);
    switch (networkResult.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: networkResult.status.data.result.data ?? [],
          },
        };
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
